import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'

interface ModalProps {
  children: React.ReactNode
  className?: string
}

export const Modal: React.FC<ModalProps> = (props) => {
  const modalRoot = document.getElementById('modal-root')
  const el = document.createElement('div')

  useEffect(() => {
    if (modalRoot) {
      if (props.className) el.classList.add(props.className)
      modalRoot.appendChild(el)
    }
    return function () {
      if (modalRoot) {
        modalRoot.removeChild(el)
        if (props.className) el.classList.remove(props.className)
      }
    }
  })

  // Use a portal to render the children into the element
  return createPortal(props.children, el)
}
